import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import React from "react";

const DataTablesPermissions = (props) => {

  const { role } = props;

  return (
    <>
      <Card className="bg-gray">
        <Card.Body>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">LOINC</span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    LOINC Table
                  </span>
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View LOINC Codes In Table
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Remove Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New LOINC Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Col style={{ display: "flex", justifyContent: "center" }}>
                <Card style={{ width: "500px", marginTop: "75px" }}>
                  <Row style={{ marginTop: "10px", marginBottom: "10px" }}>
                    <Col className="offset-1 textSmallFontBig">
                      Permissions:
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <Col sm={3} className="offset-1 textSmallFontBig">
                      <div>Can Edit</div>
                    </Col>
                    <Col>
                      <div>(Visible and can perform screen action)</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={3} className="offset-1 textSmallFontBig">
                      <div>Can Read</div>
                    </Col>
                    <Col>
                      <div>(Visible on Screen but Cannot Edit)</div>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: "10px" }}>
                    <Col sm={3} className="offset-1 textSmallFontBig">
                      <div>Cannot Read</div>
                    </Col>
                    <Col>
                      <div>(Not visible on Screen)</div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Col>
          </Row>
          <Row style={{ marginTop: "45px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    LOINC Table (Add New LOINC)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Submit Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "100px", marginTop: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    LOINC Table (Update LOINC)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Submit Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">AOE LOINC</span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    AOE LOINC Table
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View AOE LOINC Codes In Table
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Remove Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New AOE LOINC Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    AOE LOINC Table (Add AOE LOINC)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    AOE LOINC Table (Update AOE LOINC)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">
                Reporting LOINC
              </span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Reporting LOINC Table
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View Reporting LOINC Codes In Table
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Remove Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add new Reporting LOINC Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Reporting LOINC Table (Add new Reporting LOINC)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Reporting LOINC Table (Update Reporting LOINC)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">SNOMED</span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    SNOMED Table
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View SNOMED Codes In Table
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Remove Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New SNOMED Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    SNOMED Table (Add New SNOMED)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    SNOMED Table (Update SNOMED)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">Condition</span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Condition Table
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View Conditions In Table
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Remove Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New Condition Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Condition Table (Add New Condition)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Condition Table (Update Condition)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">
                Sending Facility
              </span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Sending Facility Table
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View Facilities In Table
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Remove Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New Facility Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Sending Facility Table (Add New Facility)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">NPI Field</span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    CLIA Field
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">OID Field</span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Facility Id Field
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Status Field
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Can Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Submit Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Sending Facility Table (Update Facility)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">NPI Field</span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Can Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    NPI Field Is Blank
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    CLIA Field
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Can Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    CLIA Field Is Blank
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">OID Field</span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Can Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    OID Field Is Blank
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Facility Id Field
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Can Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Submit Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">
                Performing Facility
              </span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Performing Facility Table
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View Performing Facilities In Table
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Remove Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New Facility Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Performing Facility Table (Add New Facility)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Status Field
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Performing Facility Table (Update Facility)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Status Field
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>

          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">
                Code Sets Management
              </span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Code Sets
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New Value Set Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Remove Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Code Sets (Update Value Set)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New Value
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Delete Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default DataTablesPermissions;
